import { render } from "./ModelSelect.vue?vue&type=template&id=222bc08a"
import script from "./ModelSelect.vue?vue&type=script&lang=ts"
export * from "./ModelSelect.vue?vue&type=script&lang=ts"
script.render = render

export default script